import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import { classNames } from 'src/utils/helpers';

function Cta({ cta: { title, tagline, link, isTwoColLayout, image, isDark } }) {
  if (isTwoColLayout) {
    return (
      <div
        /**
         * Added a z-index to the link because the next page section's animation had negative margins,
         * and the button was shadowed by the animation.
         * */
        className={classNames('bg-shapes-cta  py-5', {
          'mb-7': image,
          'bg-shapes-cta': !isDark,
          'bg-shapes-cta-dark': isDark,
          'bg-darker': isDark,
        })}
      >
        <Container as="section">
          <Row className="justify-content-center">
            <Col xs={12} lg={10} className="py-6">
              <Row className="align-items-center justify-content-around text-lg-left text-center">
                <Col xs={12} lg={6}>
                  {tagline && <Col className={`text-uppercase ${isDark ? 'text-secondary' : 'text-primary'}`}>{tagline}</Col>}
                  {title && <Col className={`h2 mb-lg-0 mb-3 ${isDark ? 'text-white' : ''}`}>{title}</Col>}
                </Col>
                <Col xs="auto">
                  <Link
                    to={link.url}
                    className={`z-index-1 position-relative  btn  ${isDark ? 'btn-gradient-secondary' : 'btn-gradient-primary'}`}
                  >
                    {link.title}
                  </Link>
                </Col>
              </Row>
            </Col>
            {image && (
              <Col xs={12} className="mt-5">
                <GatsbyImage id={image?._key} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} alt={image?.alt ?? ''} />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <Container
      as="section"
      fluid
      className={classNames('bg-shapes-cta  py-5', {
        'mb-7': image,
      })}
    >
      <Row className="text-center">
        <Col xs={12} className="py-5">
          {tagline && (
            <Col xs={12} className="text-uppercase">
              {tagline}
            </Col>
          )}
          {title && (
            <Col xs={12} as="h2" className="mb-6 mt-2">
              {title}
            </Col>
          )}
          <Link to={link.url} className={`z-index-1 position-relative  btn  ${isDark ? 'btn-gradient-secondary' : 'btn-gradient-primary'}`}>
            {link.title}
          </Link>
        </Col>
        {image && (
          <Col xs={12} className="mt-5">
            <Col xs={12} className="mt-5">
              <GatsbyImage id={image?._key} image={image?.image?.asset?.gatsbyImageData} alt={image?.alt ?? ''} />
            </Col>
          </Col>
        )}
      </Row>
    </Container>
  );
}

Cta.propTypes = {
  cta: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tagline: PropTypes.string,
    link: PropTypes.shape({}).isRequired,
    isTwoColLayout: PropTypes.bool,
    image: PropTypes.shape({}),
  }).isRequired,
};

export default Cta;
